module.exports = __webpack_public_path__ + "src/routes/solution/banner.png?fcec25bc";


//////////////////
// WEBPACK FOOTER
// ./src/routes/solution/banner.png
// module id = 2869
// module chunks = 1